<template>
  <div>
    <my-notification :icon="'play-circle-o'" v-if="header">
      <template #title>
        {{ $t('compAdminWebinar.title-1') }}
      </template>
    </my-notification>
    <div class="columns">
      <div class="column">
        <br /><br />
        <div class="has-text-centered">
          <iframe
            style="height: 250px"
            src="https://peer.tube/videos/embed/hiQ9EZc6mhwZUBBgahcxVD"
            frameborder="0"
            width="90%"
            height="250px"
            sandbox="allow-same-origin allow-scripts"
            allowfullscreen="allowfullscreen"
          >
          </iframe>
        </div>
        <b-notification :closable="false" class="ml-5 mr-5">
          <strong>Webinaire GES & Ekocentral Scenario</strong>
          <div style="position: absolute; top: 20px; right: 20px">
            <span class="subtitle is-muted is-size-6">7-05-2024</span>
          </div>
          <br />
          <small>
            <a
              class="link"
              target="_blank"
              href="https://peer.tube/w/hiQ9EZc6mhwZUBBgahcxVD"
              ><span class="icon is-small"
                ><i class="fa fa-play-circle-o"></i
              ></span>
              Vidéo</a
            >
            &
            <a
              class="link"
              target="_blank"
              href="/static/carbon/webinaire_GES1point5_slides.pdf"
              ><span class="icon is-small"
                ><i class="fa fa-file-pdf-o"></i
              ></span>
              Présentation</a
            >
          </small>
          <br /><br />
          Le tutoriel s'adresse à la fois à ceux qui utilisent déjà l'outil mais
          aussi à toute personne qui souhaiterait initier une démarche de
          quantifiation et de scénarisation. Déroulement :
          <ul style="list-style-type: square; margin-left: 25px">
            <li>présentation des fonctionnalités de GES 1point5 ;</li>
            <li>présentation des fonctionnalités de Ekocentral Scenario ;</li>
            <li>échanges avec les participant.e.s. ;</li>
          </ul>
        </b-notification>
      </div>
      <div class="column">
        <br /><br />
        <div class="has-text-centered">
          <iframe
            style="height: 250px"
            src="https://tube.nuagelibre.fr/videos/embed/6883058d-2cd4-42f9-a331-bd17f7013b7d"
            frameborder="0"
            width="90%"
            height="250px"
            sandbox="allow-same-origin allow-scripts"
            allowfullscreen="allowfullscreen"
          >
          </iframe>
        </div>
        <b-notification :closable="false" class="ml-5 mr-5">
          <strong> Webinaire transition </strong>
          <div style="position: absolute; top: 20px; right: 20px">
            <span class="subtitle is-muted is-size-6">7-12-2023</span>
          </div>
          <br />
          <small>
            <a
              class="link"
              target="_blank"
              href="https://tube.nuagelibre.fr/videos/watch/6883058d-2cd4-42f9-a331-bd17f7013b7d"
              ><span class="icon is-small"
                ><i class="fa fa-play-circle-o"></i
              ></span>
              Vidéo</a
            >
            &
            <a
              class="link"
              target="_blank"
              href="https://labos1point5.org/static/seminaires/Webinaire_Transition_2023.pdf"
              ><span class="icon is-small"
                ><i class="fa fa-file-pdf-o"></i
              ></span>
              Présentation</a
            >
          </small>
          <br /><br />
          <p>Programme :</p>
          <ul
            style="list-style-type: square; margin-top: 5px; margin-left: 25px"
          >
            <li style="padding-top: 3px">
              Introduction -
              <strong>Marie-Alice Foujols et Céline Serrano</strong> (GDR Labos
              1point5)
            </li>
            <li style="padding-top: 3px">
              Présentation de la charte du réseau -
              <strong>Nunzia Savoia</strong> (CNRS)
            </li>
            <li style="padding-top: 3px">
              Du diagnostic à l'action : comprendre les freins organisationnels
              et matériels à la transition climatique de l'enseignement
              supérieur et la recherche -
              <strong>Emmanuel Monneau</strong> (LISIS)
            </li>
            <li style="padding-top: 3px">
              Démonstration de la plateforme(béta version) -
              <strong>Matthieu Simonin</strong> (GDR Labos 1point5)
            </li>
            <li style="padding-top: 3px">Questions-réponses</li>
          </ul>
        </b-notification>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Webinar',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  props: ['header']
}
</script>
